package com.crowpay.views.components

import com.crowpay.views.components.nav.AppDimensions
import com.crowpay.views.components.nav.viewIsWide
import com.lightningkite.kiteui.models.Dimension
import com.lightningkite.kiteui.models.div
import com.lightningkite.kiteui.models.dp
import com.lightningkite.kiteui.models.px
import com.lightningkite.kiteui.views.ViewDsl
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.expanding
import kotlin.contracts.ExperimentalContracts
import kotlin.contracts.InvocationKind
import kotlin.contracts.contract


@ViewDsl
fun RowOrCol.space(value: Dimension, setup: Space.()->Unit = {}) =
    sizeConstraints(minWidth = if(vertical) 1.dp else value, minHeight = if(vertical) value else 1.dp) - space(setup)


@ViewDsl
fun RowCollapsingToColumn.space(value: Dimension) {
    sizeConstraints(minWidth = value, minHeight = value) - space()
}

enum class Indent(val before: Dimension, val after: Dimension) {
    Full(AppDimensions.fullIndent, AppDimensions.backgroundIndent),
    Section(AppDimensions.sectionIndent, 0.px),
    HalfSection(AppDimensions.sectionIndent/2, 0.px),
    CenteredSection(AppDimensions.sectionIndent, AppDimensions.sectionIndent),
    Tab(AppDimensions.tabSectionPadding, 0.px)
}

@OptIn(ExperimentalContracts::class)
@ViewDsl
inline fun ViewWriter.indentedCol(
    beforeSpace: Dimension,
    afterSpace: Dimension,
    width: Dimension? = null,
    setup: RowOrCol.() -> Unit
): ViewModifiable {
    contract { callsInPlace(setup, InvocationKind.EXACTLY_ONCE) }
    return stack {     // stack is here for animation purposes
        row {
            space(beforeSpace)
            if (width != null) sizeConstraints(width = width) else expanding
            col(setup)
            if (afterSpace > 0.px) space(afterSpace)
        }
    }
}

@OptIn(ExperimentalContracts::class)
@ViewDsl
inline fun ViewWriter.indentedCol(
    indent: Indent,
    width: Dimension? = null,
    setup: RowOrCol.() -> Unit
): ViewModifiable {
    contract { callsInPlace(setup, InvocationKind.EXACTLY_ONCE) }
    return indentedCol(indent.before, indent.after, width, setup)
}

@ViewDsl fun ViewWriter.sectionIndentCol(width: Dimension? = null, setup: RowOrCol.()->Unit) = indentedCol(Indent.Section, width, setup)
@ViewDsl fun ViewWriter.fullIndentCol(width: Dimension? = null, setup: RowOrCol.() -> Unit) = indentedCol(Indent.Full, width, setup)
@ViewDsl fun ViewWriter.tabIndentCol(width: Dimension? = null, setup: RowOrCol.() -> Unit) = indentedCol(Indent.Tab, width, setup)

@ViewDsl
inline fun ViewWriter.indentIfWideCol(
    indent: Indent,
    width: Dimension? = null,
    setup: RowOrCol.() -> Unit
) =
    if (viewIsWide) indentedCol(indent, width, setup)
    else col(setup)
